export enum RelationshipType {
  EXPOSURE = 'exposure',
  CONTACT = 'contact'
}
